import { useContext } from "react";
import { Switch } from "@headlessui/react";
import { LanguageContext } from "../contexts/LanguageProvider";
import { LANGUAGES } from "../constant/languages";

const LanguageSelector = () => {
  const { language, setLanguage } = useContext(LanguageContext);

  const handleToggle = () => {
    setLanguage(language === LANGUAGES.JA ? LANGUAGES.EN : LANGUAGES.JA);
  };

  return (
    <div className="flex items-center space-x-4 justify-end mt-4">
      <span className="text-gray-700 font-medium">English</span>
      <Switch
        checked={language === LANGUAGES.EN}
        onChange={handleToggle}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${
          language === LANGUAGES.EN ? "bg-blue-600" : "bg-gray-300"
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
            language === LANGUAGES.EN ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </Switch>
    </div>
  );
};

export default LanguageSelector;